import { AxiosGlobalFilters } from '../config';

export const ChamadoService = {
  getOccurences: ({
    dataInicio,
    dataFim,
    pageSize,
    pageIndex,
    empresa,
    UnidadeId,
    AreaId,
    EquipamentoId,
    Search,
    StatusIds,
    SolicitanteId,
    StatusAprovacao,
    NaoAutorizadas,
    OcorrenciaTipica,
  }) => {
    const url = `/v3/ocorrencias`;
    const headers = {
      'content-type': 'application/json',
      EmpresaId: empresa,
    };

    if (UnidadeId !== undefined && UnidadeId !== null) {
      headers.UnidadeId = UnidadeId;
    }
    return AxiosGlobalFilters({
      method: 'GET',
      url,
      headers,
      params: {
        AreaId,
        EquipamentoId,
        Search,
        StatusIds,
        SolicitanteId,
        StatusAprovacao,
        NaoAutorizadas,
        PAgeSize: pageSize,
        PageIndex: pageIndex,
        DataInicio: dataInicio,
        DataTermino: dataFim,
        OcorrenciaTipica,
      },
    });
  },
  getOcurrencesNumber: ({
    dataInicio,
    dataFim,
    empresa,
    UnidadeId,
    AreaId,
    EquipamentoId,
    Search,
    StatusIds,
    SolicitanteId,
  }) => {
    const url = `/v1/ocorrencias/count?DataInicio=${dataInicio}&DataTermino=${dataFim}`;
    const headers = {
      'content-type': 'application/json',
      EmpresaId: empresa,
    };

    if (UnidadeId !== undefined && UnidadeId !== null) {
      headers.UnidadeId = UnidadeId;
    }
    return AxiosGlobalFilters({
      method: 'GET',
      url,
      headers,
      params: {
        AreaId,
        EquipamentoId,
        Search,
        StatusIds,
        SolicitanteId,
      },
    });
  },
  getOcurrencesData: ({ anomaliaGid, empresa }) => {
    const url = `/v3/ocorrencias/${anomaliaGid}/toedit`;
    return AxiosGlobalFilters({
      method: 'GET',
      url,
      headers: {
        'content-type': 'application/json',
        EmpresaId: empresa,
      },
    });
  },
  getCorrections: ({ anomaliaGid, empresa }) => {
    const url = `/v3/correcoes?ocorrenciaId=${anomaliaGid}`;
    return AxiosGlobalFilters({
      method: 'GET',
      url,
      headers: {
        'content-type': 'application/json',
        EmpresaId: empresa,
      },
    });
  },
  getEquipments: ({ empresa, SiteId, AreaId, GrupoAreaId, SubGrupoAreaId, Search = null, PageIndex, PageSize }) => {
    return AxiosGlobalFilters({
      method: 'GET',
      url: 'v1/equipamentos',
      params: {
        SiteId,
        AreaId,
        GrupoAreaId,
        SubGrupoAreaId,
        Search,
        PageIndex,
        PageSize,
      },
      headers: {
        'content-type': 'application/json',
        EmpresaId: empresa,
      },
    });
  },
  getAreas: ({ empresa, siteId, grupoAreaId, subGrupoAreaId, Search = null, PageIndex, PageSize }) => {
    return AxiosGlobalFilters({
      method: 'GET',
      url: '/v1/areas',
      params: {
        SiteId: siteId,
        GrupoAreaId: grupoAreaId,
        SubGrupoAreaId: subGrupoAreaId,
        Search,
        PageIndex,
        PageSize,
      },
      headers: {
        'content-type': 'application/json',
        EmpresaId: empresa,
      },
    });
  },
  getGrupoAreas: ({ empresa, siteId }) => {
    return AxiosGlobalFilters({
      method: 'GET',
      url: 'v1/gruposareas/ativos',
      params: {
        empresaId: empresa,
        unidadeId: siteId,
      },
      headers: {
        'content-type': 'application/json',
        EmpresaId: empresa,
        UnidadeId: siteId,
      },
    });
  },
  getSubGrupoAreas: ({ empresa, siteId, grupoAreaId }) => {
    return AxiosGlobalFilters({
      method: 'GET',
      url: 'v1/subgruposareas/ativos',
      params: {
        empresaId: empresa,
        unidadeId: siteId,
        grupoAreaId,
      },
      headers: {
        'content-type': 'application/json',
        EmpresaId: empresa,
        UnidadeId: siteId,
      },
    });
  },
  saveOccurences: ({ EmpresaId, UnidadeId, data, validarDuplicidade }) => {
    return AxiosGlobalFilters({
      method: 'POST',
      url: 'v3/ocorrencias',
      data: {
        ...data,
        validarDuplicidade,
      },
      headers: {
        'content-type': 'application/json',
        EmpresaId,
        UnidadeId,
      },
    });
  },
  getOcorrenciasTipicas: ({ EmpresaId, UnidadeId, system, grupoAreadId, subGrupoAreadId, tipoEquipamentoId }) => {
    return AxiosGlobalFilters({
      method: 'GET',
      url: `v1/ocorrencias/tipicas/${EmpresaId}`,
      params: {
        siteId: UnidadeId,
        sistemaEmpresaId: system,
        grupoAreadId,
        subGrupoAreadId,
        tipoEquipamentoId,
      },
      headers: {
        'content-type': 'applications/json',
        EmpresaId,
        UnidadeId,
      },
    });
  },
  getCompanyConfig: ({ empresaId }) => {
    return AxiosGlobalFilters({
      method: 'get',
      url: `v3/ocorrencias/config/${empresaId}`,
      headers: {
        'content-type': 'applications/json',
        EmpresaId: empresaId,
      },
    });
  },
  aproveOcurrence: ({ empresaId, unidadeId, data }) => {
    return AxiosGlobalFilters({
      url: 'v3/ocorrencias/aprovacao',
      method: 'put',
      data,
      headers: {
        'conten-type': 'application/json',
        EmpresaId: empresaId,
        UnidadeId: unidadeId,
      },
    });
  },
  authorizeOcurrence: ({ empresaId, unidadeId, data }) => {
    return AxiosGlobalFilters({
      url: 'v3/ocorrencias/autorizacao',
      method: 'put',
      data,
      headers: {
        'conten-type': 'application/json',
        EmpresaId: empresaId,
        UnidadeId: unidadeId,
      },
    });
  },
  getCorrectionsTypes: ({ empresaId, unidadeId }) => {
    return AxiosGlobalFilters({
      method: 'get',
      url: 'v3/correcoes/tipos',
      headers: {
        'conten-type': 'application/json',
        EmpresaId: empresaId,
        UnidadeId: unidadeId,
      },
    });
  },
};
